import { all, put, call, takeLatest } from 'redux-saga/effects';
import {
  showLoading,
  hideLoading,
  showPullToRefresh,
  hidePullToRefresh
} from '../../actions/Login/action';
import * as constants from '../../utils/constants';
import request from '../../utils/request';
import {
  loadData,
  addWatchLoadSuccess,
  removeWatchLoadSuccess,
  recommendedLoadsSuccess,
  similarLoadsSuccess,
  fetchAvailableLoadsSuccess,
  watchLoadsResponse,
  toprecommendedLoadsSuccess
} from '../../actions/Home/action';
import { DomainConverter } from '../../utils/common';
const APPLICATION_JSON = 'application/json';

export function* updateData() {
  try {
    yield put(showLoading());
    const repos = yield call(request, ['HOME', 'RECOMMENDED_LOADS']);
    yield put(loadData(repos));
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}
export function* watchedLoads(action: any) {
  try {
    yield put(
      action.payload.isPullToRefresh ? showPullToRefresh() : showLoading()
    );
    const watchedReqestQuery = DomainConverter.domainToData<any>(
      action.payload.query
    );
    const watchedResults = yield call(request, [
      'RECENT',
      'RECENT',
      null,
      '',
      watchedReqestQuery,
      APPLICATION_JSON
    ]);
    yield put(
      watchLoadsResponse({
        watchedResults,
        refreshStatus: action.payload.refreshStatus
      })
    );
    yield put(
      action.payload.isPullToRefresh ? hidePullToRefresh() : hideLoading()
    );
    if (action.payload.callback) {
      const results =
        (watchedResults &&
          watchedResults.data &&
          watchedResults.data.getUserWatchedLoads &&
          watchedResults.data.getUserWatchedLoads.loadPostings) ||
        [];
      action.payload.callback(results.length);
    }
  } catch (e) {
    yield put(
      action.payload.isPullToRefresh ? hidePullToRefresh() : hideLoading()
    );
  }
}

export function* recommendedLoads(action: any) {
  try {
    yield put(
      action.payload.refreshStatus ? showPullToRefresh() : showLoading()
    );
    const recommendedReqestQuery = DomainConverter.domainToData<any>(
      action.payload.query
    );
    const recommendedResults = yield call(request, [
      'HOME',
      'RECOMMENDED_LOADS',
      null,
      '',
      recommendedReqestQuery,
      APPLICATION_JSON
    ]);
    if (action.payload.isTopRecomm &&
      recommendedResults &&
      recommendedResults.data &&
      recommendedResults.data.recommendedLoads &&
      recommendedResults.data.recommendedLoads.loadPostings
    ) {
      yield put(
        toprecommendedLoadsSuccess({
          topRecommData: recommendedResults.data.recommendedLoads.loadPostings
            .filter((load: any) => load.loadPostingStatus.toLowerCase() === "new")
            .sort((a: any, b: any) => { return a.rank - b.rank })
            .slice(0, 2),
          refreshStatus: action.payload.refreshStatus || action.payload.sorRefresh
        })
      );
    }
    else {
      yield put(
        recommendedLoadsSuccess({
          recommendedResults,
          refreshStatus: action.payload.refreshStatus || action.payload.sorRefresh
        })
      );
    }
    yield put(
      action.payload.refreshStatus ? hidePullToRefresh() : hideLoading()
    );
    if (action.payload.callback) {
      const results =
        (recommendedResults &&
          recommendedResults.data &&
          recommendedResults.data &&
          recommendedResults.data.recommendedLoads &&
          recommendedResults.data.recommendedLoads.loadPostings &&
          recommendedResults.data.recommendedLoads.loadPostings) ||
        [];
      action.payload.callback(results.length);
    }
  } catch (e) {
    yield put(
      action.payload.refreshStatus ? hidePullToRefresh() : hideLoading()
    );
  }
}

export function* getSimilarLoads(action: any) {
  try {
    const similarLoadsReqestQuery = DomainConverter.domainToData<any>(
      action.payload.data.query
    );
    const similarResults = yield call(request, [
      'HOME',
      'SIMILAR_LOADS',
      null,
      '',
      similarLoadsReqestQuery,
      APPLICATION_JSON
    ]);
    yield put(
      similarLoadsSuccess({
        similarResults, primaryLoadId: action.payload.data.primaryLoadId
      })
    );
    yield action.payload.callback(similarResults);
  } catch (e) {
    yield action.payload.callback();
  }
}

export function* fetchAvailableLoads(action: any) {
  try {
    yield put(showLoading());
    const availableStopReqestQuery = DomainConverter.domainToData<any>(
      action.payload.data.query
    );
    const availableLoadResults = yield call(request, [
      'HOME',
      'DETAILED_LOADS',
      null,
      '',
      availableStopReqestQuery,
      APPLICATION_JSON
    ]);

    yield put(
      fetchAvailableLoadsSuccess({
        availableLoadResults, loadId: action.payload.data.loadId
      })
    );
    yield put(hideLoading());
    if (action.payload.callback) {
      action.payload.callback(availableLoadResults);
    }
  } catch (e) {
    yield put(hideLoading());
  }
}



export function* addWatchLoad(data: any) {
  const { query, loadDetails } = data.payload;
  try {
    yield put(showLoading());
    const value = DomainConverter.domainToData<any>(query);
    const repos = yield call(request, [
      'RECENT',
      'RECENT',
      null,
      '',
      value,
      APPLICATION_JSON
    ]);
    yield put(addWatchLoadSuccess(loadDetails));
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}


export function* removeWatchLoad(data: any) {
  const { query, loadId, callback } = data.payload;
  try {
    yield put(showLoading());
    const value = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      'RECENT',
      'RECENT',
      null,
      '',
      value,
      APPLICATION_JSON
    ]);
    yield put(removeWatchLoadSuccess({ loadId }));
    yield put(hideLoading());
    callback(response.errors ? true : false);
  } catch (e) {
    callback(true);
    yield put(hideLoading());
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(constants.UPDATE_DATA, updateData),
    takeLatest(constants.RECOMMENDED_LOADS_REQUEST, recommendedLoads),
    takeLatest(constants.WATCHEDLOAD_DATA_REQUEST, watchedLoads),
    takeLatest(constants.ADD_WATCH_LOAD, addWatchLoad),
    takeLatest(constants.REMOVE_WATCH_LOAD, removeWatchLoad),
    takeLatest(constants.SIMILAR_LOADS_REQUEST, getSimilarLoads),
    takeLatest(constants.AVAILABLE_LOADS_REQUEST, fetchAvailableLoads)
  ]);
}
